import React from "react";
import { Button, Form, Input, Select, Space } from "antd";
import PhoneNumberInput from "../../../../components/shared/PhoneNumberInput";

const DESIGNATIONS = ["Mr", "Mrs", "Ms", "Dr", "Miss"].map((d) => ({ label: d, value: d }));

export interface BasicInfoValues {
  designation?: string;
  name: string;
  email: string;
  phone: string;
}

interface Props {
  initialValues: BasicInfoValues | null;
  onNext: (values: BasicInfoValues) => void;
}

export default function BasicInfoStep({ initialValues, onNext }: Props) {
  const [form] = Form.useForm<BasicInfoValues>();

  return (
    <div className="customize-tour-form__step-body">
      <Form form={form} layout="vertical" initialValues={initialValues || undefined} onFinish={onNext}>
        <Form.Item label="Your Name*" required={false}>
          <Space.Compact style={{ width: "100%", display: "flex" }}>
            <Form.Item name="designation" noStyle rules={[{ required: true, message: "Please select a designation" }]}>
              <Select placeholder="Designation" style={{ width: 155, flexShrink: 0 }} options={DESIGNATIONS} />
            </Form.Item>
            <Form.Item name="name" noStyle rules={[{ required: true, message: "Please enter your name" }]}>
              <Input placeholder="What should we call you?" />
            </Form.Item>
          </Space.Compact>
        </Form.Item>

        <Form.Item
          label="Email*"
          name="email"
          required={false}
          rules={[
            { required: true, message: "Please enter your email" },
            { type: "email", message: "Please enter a valid email" },
          ]}
        >
          <Input placeholder="Example: johndoe@gmail.com" />
        </Form.Item>

        <Form.Item
          label="Contact Number*"
          name="phone"
          required={false}
          rules={[{ required: true, message: "Please enter your contact number" }]}
        >
          <PhoneNumberInput />
        </Form.Item>

        <div className="customize-tour-form__actions customize-tour-form__actions--center">
          <Button type="primary" htmlType="submit" className="customize-tour-form__btn-continue">
            Continue
          </Button>
        </div>
      </Form>
    </div>
  );
}
